/* eslint-disable no-unused-vars */

export enum conversationConstant {
  GET_CONVERSATIONS = 'GET_CONVERSATIONS',
  EDIT_CONVERSATION_NAME = 'EDIT_CONVERSATION_NAME',
  UPDATE_CONVERSATIONS = 'UPDATE_CONVERSATIONS',
  UPDATE_STATUS = 'UPDATE_STATUS',
  UPDATE_CURRENT_QUESTION = 'UPDATE_CURRENT_QUESTION',
  UPDATE_CURRENT_CONVERSATION = 'UPDATE_CURRENT_CONVERSATION',
  UPDATE_PROCESS_CONVERSATION_ID = 'UPDATE_PROCESS_CONVERSATION_ID',
  UPDATE_CURRENT_CONVERSATION_DATA = 'UPDATE_CURRENT_CONVERSATION_DATA',
  GET_LATEST_CONVERSATION = 'GET_LATEST_CONVERSATION',
  GET_DETAIL_CONVERSATION = 'GET_DETAIL_CONVERSATION',
  ADD_NEW_QUESTION = 'ADD_NEW_QUESTION',
  ADD_NEW_CONVERSATION = 'ADD_NEW_CONVERSATION',
  UPDATE_SELECTED_CITATION = 'UPDATE_SELECTED_CITATION',
  UPDATE_NEW_ANSWER = 'UPDATE_NEW_ANSWER',
  DELETE_CONVERSATION = 'DELETE_CONVERSATION',
  UPDATE_VIEW_MODE = 'UPDATE_VIEW_MODE',
  UPDATE_NEW_QUESTION = 'UPDATE_NEW_QUESTION',
  UPDATE_LIMIT_STATUS = 'UPDATE_LIMIT_STATUS',
  EDIT_QUESTION = 'EDIT_QUESTION',
  RESET_DATA = 'RESET_DATA',
  UPDATE_PROCESSING_STREAMING_CHUNK_STATUS = 'UPDATE_PROCESSING_STREAMING_CHUNK_STATUS',
  UPDATE_NEW_STREAMING_ANSWER_CHUNKS = 'UPDATE_NEW_STREAMING_ANSWER_CHUNKS',
  CLEAR_STREAMING_ANSWER_CHUNKS = 'CLEAR_STREAMING_ANSWER_CHUNKS',
  SET_TIMEOUT_FOR_FINAL_ANSWER = 'SET_TIMEOUT_FOR_FINAL_ANSWER',
}
